import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function navigateTo(platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('navigateTo')) {
        return;
    }

    function helper(featureName: string): void;
    function helper(featureName: string, moduleName: string): void;
    function helper(featureName: string, urlParams: any[]): void;
    function helper(featureName: string, queryParams: IDict<any>): void;
    function helper(featureName: string, urlParams: any[], queryParams: IDict<any>): void;
    function helper(featureName: string, moduleName: string, urlParams: any[]): void;
    function helper(featureName: string, moduleName: string, queryParams: IDict<any>): void;
    function helper(
        featureName: string,
        moduleName: string,
        urlParams: any[],
        queryParams: IDict<any>
    ): void;
    function helper(
        featureName: string,
        arg2?: string | any[] | IDict<any>,
        arg3?: any[] | IDict<any>,
        arg4?: IDict<any>
    ): void {
        let moduleName;
        let urlParams;
        let queryParams;

        if (typeof arg2 === 'string') {
            moduleName = arg2;
        } else if (Array.isArray(arg2)) {
            urlParams = arg2;
        } else if (arg2) {
            queryParams = arg2;
        }

        if (Array.isArray(arg3)) {
            urlParams = arg3;
        } else if (arg3) {
            queryParams = arg3;
        }

        if (arg4) {
            queryParams = arg4;
        }

        sendMessage(
            `navigateTo`,
            Maybe.just({ featureName, moduleName, urlParams, queryParams }).map(JSON.stringify)
        );
    }

    return helper;
}
